/**
 * WebMCP API Integration (Chrome WebMCP Standard)
 * Exposes site capabilities to AI Browser Agents via navigator.modelContext
 */
(function initWebMCP() {
  function registerTools() {
    const tools = [
      {
        name: "search_products",
        description: "Search Half Price Print catalog for custom printing products and boxes",
        inputSchema: {
          type: "object",
          properties: {
            query: { type: "string", description: "Search term like business cards, mailer boxes, banners" }
          },
          required: ["query"]
        },
        execute: async ({ query }) => {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product`);
          return await res.json();
        }
      },
      {
        name: "get_cart",
        description: "Retrieve current shopping cart state and line items",
        inputSchema: {
          type: "object",
          properties: {}
        },
        execute: async () => {
          const res = await fetch('/cart.js');
          return await res.json();
        }
      },
      {
        name: "add_to_cart",
        description: "Add a product variant to cart with specified quantity",
        inputSchema: {
          type: "object",
          properties: {
            id: { type: "number", description: "Product variant ID" },
            quantity: { type: "number", description: "Quantity to add" }
          },
          required: ["id", "quantity"]
        },
        execute: async ({ id, quantity }) => {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity }] })
          });
          return await res.json();
        }
      }
    ];

    window.__webMcpTools = tools;

    if (typeof navigator !== 'undefined' && navigator.modelContext && typeof navigator.modelContext.provideContext === 'function') {
      try {
        navigator.modelContext.provideContext({ tools });
      } catch (e) {
        console.warn("WebMCP offer context error:", e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerTools);
  } else {
    registerTools();
  }
})();
